/*
* @Author: LH
* @Date:   2018-08-11 23:34:51
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-13 16:39:16
*/
import { service } from '@/utils/request'

export default {
	//列表
	getDataList(params) {
		return service({
			url: '/cloud/mission/v1/mission/admin/listForAdmin',
			method: 'get',
			params: params
		})
	},
	/**
	 * [switch 上下架开关]
	 * @param  {[obj]} params [id，status]
	 * @return {[obj]}
	 */
	switch(params) {
	 	return service({
	 		url: '/cloud/mission/v1/mission/admin/updateStatus',
	 		method: 'get',
	 		params: params
	 	})
	},
	/**
	 * [create 创建任务]
	 * @param  {[obj]} data [表单数据]
	 * @return {[obj]}
	 */
	create(data) {
	 	return service({
	 		url: '/cloud/mission/v1/mission/admin/create',
	 		method: 'post',
	 		data: data
	 	})
	},
	/**
	 * [create 更新任务]
	 * @param  {[obj]} data [表单数据]
	 * @return {[obj]}
	 */
	update(data) {
	 	return service({
	 		url: '/cloud/mission/v1/mission/admin/update',
	 		method: 'post',
	 		data: data
	 	})
	 },
	getData(params) {
	 	return service({
	 		url: '/cloud/mission/v1/mission/admin/findById',
	 		method: 'get',
	 		params
	 	})		
	},
	 // 删除
	deleteData(params) {
	 	return service({
	 		url: '/cloud/mission/v1/mission/admin/delete',
	 		method: 'post',
	 		params
	 	})		
	},
	// 上架的卡种	
	getVipCardList(params) {
	 	return service({
	 		url: '/cloud/mission/v1/mission/admin/getVipCardList',
	 		method: 'get'
	 	})		
	}
}


// WEBPACK FOOTER //
// ./src/api/operateManage/taskManage.js